// REDUCER FOR COMPANY LIST
export function companylistdata(state = [], action) {
    switch (action.type) {
        case 'COMPANY LIST':
        // console.log(action.data,"companylist")
            return action.data
        default:
            return state
    }
}